const BadgeConstants = {
  /**
   * All Cofocus platform badges.
   * @NB Ordered by order in array, not badgeNr to make changing display
   * order easier by simply switching location (otherwise would need to
   * change badge numbers for all badges after the one being moved).
   * */
  badges: [
    {
      badgeNr: 33,
      name: "Stitch Queen",
      howtoget: "Looks like you and The Little Blue Koala are true besties! :)",
      title: "Stitch Queen",
      subtitle: "Looks like you and The Little Blue Koala are true besties! :)",
      subtext: "Click below to claim your new badge 'Stitch Queen' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__7__VUFGZqzWA.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Badges__6__jFiyzUaEr.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: false,
    },

    {
      badgeNr: 34,
      name: "Founder Lost Bet",
      howtoget: "You made a bet with the founder and WON! ...and the founder lost! 😈",
      title: "Founder Lost Bet",
      subtitle: "You made a bet with the founder and WON! ...and the founder lost! 😈",
      subtext: "Click below to claim your new badge 'Founder Lost Bet' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__9__mn4CD8Du8.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Badges__8__1Jo96OHTF.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 35,
      name: "Founder Won Bet",
      howtoget: "You made a bet with the founder and LOST! ...Oops! Heheheh 😈",
      title: "Founder Won Bet",
      subtitle: "You made a bet with the founder and LOST! ...Oops! Heheheh 😈",
      subtext: "Click below to claim your new badge 'Founder Won Bet' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__9__mn4CD8Du8.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Badges__8__1Jo96OHTF.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 20,
      name: "Dino Master",
      howtoget: "Once upon a time, a conqueror of Dinosaurs walked the Earths! If you have this, you must be the conqueror!",
      title: "Dino Master",
      subtitle: "Once upon a time, a conqueror of Dinosaurs walked the Earths! If you have this, you must be the conqueror!",
      subtext: "Click below to claim your new badge 'Dino Master' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__2__zAkekDhOa.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Badges__1__OSLF4FBRF.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 27,
      name: "Je Suis Pirate",
      howtoget: "When le OG Pirate returns, there is only one question that remains. Where's rum!?",
      title: "Je Suis Pirate",
      subtitle: "When le OG Pirate returns, there is only one question that remains. Where's rum!?",
      subtext: "Click below to claim your new badge 'Je Suis Pirate' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__5__hu-oURqyy.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/Badges__6__hkxowuTT7.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 26,
      name: "Not A Cat!",
      howtoget: "When no one believes you're not a cat, the message ought be made clearer!",
      title: "Not A Cat!",
      subtitle: "When no one believes you're not a cat, the message ought be made clearer!",
      subtext: "Click below to claim your new badge 'Not A Cat!' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__3__IOY_ZsopZ.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Badges__4__fHlQhh15c.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 29,
      name: "Lord of Medals",
      howtoget: "Once upon a time, in the sunny South of England... behold! The Lord of Medals!",
      title: "Lord of Medals",
      subtitle: "Once upon a time, in the sunny South of England... behold! The Lord of Medals!",
      subtext: "Click below to claim your new badge 'Lord of Medals' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__1__8dpX-4AgY.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/Badges__8__cTtCtCDdT.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 25,
      name: "I Poet You",
      howtoget: "And the migthy poet spoke: 'Lord, what fools these mortals be!'",
      title: "I Poet You",
      subtitle: "And the migthy poet spoke: 'Lord, what fools these mortals be!'",
      subtext: "Click below to claim your new badge 'I Poet You' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges_YrubwGYnj.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Badges__1__mjDuGSI6H.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 21,
      name: "#1 HP Fan",
      howtoget: "When you love HP so much you get confused and think you like LOTR more...",
      title: "#1 HP Fan",
      subtitle: "When you love HP so much you get confused and think you like LOTR more...",
      subtext: "Click below to claim your new badge '#1 HP Fan' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__3__TARx2_13r.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Badges__4__tsxyy2dIk.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },
    {
      badgeNr: 24,
      name: "#1 LOTR Fan",
      howtoget: "When the HP folks team up to fight the LOTR world",
      title: "#1 LOTR Fan",
      subtitle: "When the HP folks team up to fight the LOTR world",
      subtext: "Click below to claim your new badge '#1 LOTR Fan' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__8__VdEx56id3.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Badges__17__7QNZfD5TE.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 28,
      name: "I Am Worthy!",
      howtoget: "The Lord Of Medals has decided you are worthy! Beware, if you are unworthy, he may remove your medal!",
      title: "I Am Worthy!",
      subtitle: "The Lord Of Medals has decided you are worthy! Beware, if you are unworthy, he may remove your medal!",
      subtext: "Click below to claim your medal 'I Am Worthy!' and return to getting stuff done!",
      action: "Claim Medal",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges__13__oYSGiCJTZ.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/Badges__14__cxK1rphsG.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 8,
      name: "Unicorn Sparkle",
      howtoget: "Become a supporter of Cofocus.",
      title: "Unicorn Sparkle",
      subtitle: "Special Powers awarded to those helping fuel the Cofocus unicorn energy!",
      subtext: "Click below to claim your new badge 'Unicorn Sparkle' and return to getting stuff done!",
      action: "Claim Badge",
      badgeSVG: "BadgeUnicorn",
      customStyle: "border-color: #8b00ff",
      viewBox: "0 0 500.00000000000006 500.00000000000006",
      scale: 1.14,
      type: "svg",
    },

    {
      badgeNr: 0,
      name: "Welcome",
      title: "Welcome on board!",
      subtitle: "We're glad to have you in our community! Here, have your first badge!",
      subtext: "Alright! Click below to begin blasting your productivity to the next dimension!",
      action: "Enter Cofocus",
      badgeSVG: "BadgeWelcome",
      viewBox: "0 0 512 512",
      scale: 1,
      type: "svg",
    },

    {
      badgeNr: 10,
      name: "I Know Cofocus",
      howtoget: "You've completed the onboarding process and are ready to go!",
      title: "I Know Cofocus!",
      subtitle: "You've completed the onboarding process and are ready to go!",
      subtext: "Click below to claim your new badge 'I Know Cofocus' and return to getting stuff done!",
      action: "Claim Badge",
      badgeSVG: "BadgeOnboarding",
      customStyle: "border-color: #cbe8e5;",
      viewBox: "0 0 500 500",
      scale: 1.14,
      type: "svg",
    },

    {
      badgeNr: 23,
      name: "Old Timer",
      howtoget: "Hello OG Cofocuseer! Thank you for being active on Cofocus when we were just starting out!",
      title: "Old Timer",
      subtitle: "Hello OG Cofocuseer! Thank you for being active on Cofocus when we were just starting out!",
      subtext: "Click below to claim your new badge 'Old Timer' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/3_MRp5VI7XP.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/3_vR_cQl4vv.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 1,
      name: "I Found A Bug",
      howtoget:
        "To get this badge, you need to discover and report to us something you've found on the platform that doesn't work... whether it's a broken button or entire page!",
      title: "New Badge!",
      subtitle: "You've played the wonderful role of helping Cofocus maintain great quality by successfully reporting a bug!",
      subtext: "Click below to claim your new badge 'I Found A Bug' and return to getting stuff done!",
      action: "Claim Badge",
      badgeSVG: "BadgeBug",
      customStyle: "border-color: #cbe8e5;",
      viewBox: "0 0 512 512",
      scale: 1,
      type: "svg",
    },

    {
      badgeNr: 30,
      name: "I Persist!",
      howtoget: "Bugs will not stop you!",
      title: "I Persist!",
      subtitle: "Bugs will not stop you!",
      subtext: "Click below to claim your new badge 'I Persist!' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/3_0bqVnAaJa.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/3_2gUfd5PAI.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 31,
      name: "Shoutout!",
      howtoget: "Thank you for giving Cofocus a shoutout!",
      title: "Shoutout!",
      subtitle: "Thank you for giving Cofocus a shoutout!",
      subtext: "Click below to claim your new badge 'Shoutout!' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/2_WNA3m524q.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/2_xIXK-Qr2D.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 32,
      name: "IG Takeover!",
      howtoget: "Looks like you took over the Cofocus Instagram account!",
      title: "IG Takeover!",
      subtitle: "Looks like you took over the Cofocus Instagram account!",
      subtext: "Click below to claim your new badge 'IG Takeover!' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Badges_nkHezXv1G.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Badges__1__1jgKvRgW4A.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 22,
      name: "Valuable Feedback",
      howtoget: "Thank you for helping us out and for making Cofocus better!",
      title: "Valuable Feedback",
      subtitle: "Thank you for helping us out and for making Cofocus better!",
      subtext: "Click below to claim your new badge 'Valuable Feedback' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/2_X8wUUH4kz.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/2_I_sidQR3u.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 11,
      name: "5 Sessions",
      howtoget: "Great job, you've completed 5 sessions!",
      title: "5 Sessions",
      subtitle: "Great job, you've completed 5 sessions!",
      subtext: "Click below to claim your new badge '5 Sessions' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/5_Ene56YJXV.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/5_MedtNJYYg.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 12,
      name: "10 Sessions",
      howtoget: "Woohoo! You've done 10 sessions like it's nothing!",
      title: "10 Sessions",
      subtitle: "Woohoo! You've done 10 sessions like it's nothing!",
      subtext: "Click below to claim your new badge '10 Sessions' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/10_Ob2stUHjn.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/7_s4MgMOyrv.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 13,
      name: "25 Sessions",
      howtoget: "Hallelujah! Already at 25 sessions? Well done!",
      title: "25 Sessions",
      subtitle: "Hallelujah! Already at 25 sessions? Well done!",
      subtext: "Click below to claim your new badge '25 Sessions' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/25_OSHec0Vif.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/8_BHfxgDKT2.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 14,
      name: "50 Sessions",
      howtoget: "Whoa! 50 Sessions — You are becoming a productivity master!",
      title: "50 Sessions",
      subtitle: "Whoa! 50 Sessions — You are becoming a productivity master!",
      subtext: "Click below to claim your new badge '50 Sessions' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/50_PvOs-G5_0.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/3_qRWIJ3IR8.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 2,
      name: "100 Sessions",
      howtoget: "Wow! You've completed a 100 sessions! You're officially a Cofocus Rock Star!",
      title: "100 Sessions",
      subtitle: "Wow! You've completed a 100 sessions! You're now officially a Cofocus Rock Star!",
      subtext: "Click below to claim your new badge '100 Sessions' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/100_H3buxpbGI.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/4_ITkHb6wtC.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 15,
      name: "250 Sessions",
      howtoget: "With 250 Sessions under your belt, you're a pro at this!",
      title: "250 Sessions",
      subtitle: "With 250 Sessions under your belt, you're a pro at this!",
      subtext: "Click below to claim your new badge '250 Sessions' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/250_XFeStDCW-.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/9_R4Vc0BpXH.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 16,
      name: "500 Sessions",
      howtoget: "You have come a long way, but you have arrived. Happy 500!",
      title: "500 Sessions",
      subtitle: "You have come a long way, but you have arrived. Happy 500!",
      subtext: "Click below to claim your new badge '500 Sessions' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/500_k9HIKMYsn.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/10_SWmsJeHNf.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 7,
      name: "500 (Special Edition)",
      howtoget: "Be Barča.",
      title: "500 (Special Edition)",
      subtitle: "Every now and then... it's time to level up and be born again as a DINOSAUR LVL500!!! You did it. You went full Dino! 🦖🦕",
      subtext: "Click below to claim your new badge '500 (Special Edition)' and return to getting stuff done!",
      action: "Claim Badge",
      badgeSVG: "Badge500",
      customStyle: "border-color: #8b00ff",
      viewBox: "0 0 500.00000000000006 500.00000000000006",
      scale: 1.14,
      type: "svg",
    },

    {
      badgeNr: 17,
      name: "750 Sessions",
      howtoget: "Holy moly! With 750 Sessions you are officially a productivity Black Belt.",
      title: "750 Sessions",
      subtitle: "Holy moly! With 750 Sessions you are officially a productivity Black Belt.",
      subtext: "Click below to claim your new badge '750 Sessions' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/750_c4cZaJLo0.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/11_zimDIkyNt.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 18,
      name: "1000 Sessions",
      howtoget: "1000 Sessions? Even Bruce Lee will not mess with you!",
      title: "1000 Sessions",
      subtitle: "1000 Sessions? Even Bruce Lee will not mess with you!",
      subtext: "Click below to claim your new badge '1000 Sessions' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/1000_xatcVu0Nj.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/6_1fRy_9_PV.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
    },

    {
      badgeNr: 3,
      name: "Bug Master",
      howtoget: "Only the most serious bug hunters of the Cofocus lands get to have this badge!",
      title: "Bug Master!",
      subtitle: "Only the finest of inspectors win the Bug Master Badge! Thank you for making Cofocus better!",
      subtext: "Click below to claim your new badge 'Bug Master' and return to getting stuff done!",
      action: "Claim Badge",
      badgeSVG: "BadgeBugMaster",
      customStyle: "border-color: #cbe8e5;",
      viewBox: "0 0 510 510",
      scale: 1,
      type: "svg",
    },

    {
      badgeNr: 4,
      name: "Community Builder",
      howtoget: "You frequently bring people together and spur activity amongst the crowd!",
      title: "Community Builder!",
      subtitle:
        "You strengthen bonds and keep the Cofocus community spirit active & buzzing! Thank you for making Cofocus a more wonderful place for everyone!",
      subtext: "Click below to claim your new badge 'Community Builder' and return to getting stuff done!",
      action: "Claim Badge",
      badgeSVG: "BadgeCommunityBuilder",
      customStyle: "border-color: #cbe8e5;",
      viewBox: "0 0 512 512",
      scale: 1,
      type: "svg",
    },

    {
      badgeNr: 5,
      name: "Founder Missed Session",
      howtoget: "Woopsie doopsie doo! Looks like the founder missed a session with you!",
      title: "Founder Missed Session!",
      subtitle:
        "Woopsie Doopsie Doo! Looks like the one person who should never miss a session just missed a session with you! Embarrassing! But since badges are like candy and candy makes everything better, here's a badge to say sorry!",
      subtext: "Click below to claim your new badge 'Founder Missed Session' and return to getting stuff done!",
      action: "Claim Badge",
      badgeSVG: "BadgeFounderMissedSession",
      customStyle: "border-color: #cbe8e5;",
      viewBox: "-68 0 511 512",
      scale: 1,
      type: "svg",
    },

    {
      badgeNr: 6,
      name: "Did 100th Alone",
      howtoget: "You stop at nothing!",
      title: "Did 100th Alone",
      subtitle: "You stop at nothing! No partner? No problem! Nonetheless, here's a doggo to reward you for your determination!",
      subtext: "Click below to claim your new badge 'Did 100th Session Alone' and return to getting stuff done!",
      action: "Claim Badge",
      badgeSVG: "Badge100Alone",
      customStyle: "border-color: #8b00ff",
      viewBox: "0 0 375 374.999991",
      scale: 1.14,
      type: "svg",
    },

    {
      badgeNr: 9,
      name: "LinkedIn Sparkle",
      howtoget: "Follow Cofocus on LinkedIn.",
      title: "LinkedIn Sparkle",
      subtitle: "Thank you for supporting us on LinkedIn!",
      subtext: "Click below to claim your new badge 'LinkedIn Sparkle' and return to getting stuff done!",
      action: "Claim Badge",
      badgeSVG: "BadgeLinkedIn",
      customStyle: "border-color: #90ccec",
      viewBox: "0 0 500 500",
      scale: 1.14,
      type: "svg",
    },

    {
      badgeNr: 19,
      name: "Contributor",
      howtoget: "Thank you for helping us out and for making Cofocus better!",
      title: "Contributor",
      subtitle: "Thank you for helping us out and for making Cofocus better!",
      subtext: "Click below to claim your new badge 'Contributor' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/contributor_qOaeD_rmJ.png",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/1_cjetoMS_g.png",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 36,
      name: "Survey Superstar",
      howtoget: "Thank you for giving us feedback to help decide what's next for Cofocus!",
      title: "Survey Superstar",
      subtitle: "Thank you for giving us feedback to help decide what's next for Cofocus!",
      subtext: "Click below to claim your new badge 'Survey Superstar' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Frame_13__4__oQRLEeAkA.png?updatedAt=1680114209515",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/Frame_13__4__oQRLEeAkA.png?updatedAt=1680114209515",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },

    {
      badgeNr: 37,
      name: "Academic Ace",
      howtoget: "Cofocus congratulates you on your academic achievements!",
      title: "Academic Ace",
      subtitle: "Cofocus congratulates you on your academic achievements!",
      subtext: "Click below to claim your new badge 'Academic Ace' and return to getting stuff done!",
      action: "Claim Badge",
      badgeImageURL: "https://ik.imagekit.io/elysiumone/Badges/Copy_of_Badges_ElNuU5XQL.png?updatedAt=1665684615930",
      badgeImageURLBig: "https://ik.imagekit.io/elysiumone/Badges/1000x1000/Copy_of_Badges__1__m-JcX0OgM.png?updatedAt=1665684595350",
      customStyle: "border-color: #cbe8e5;",
      type: "regular",
      customSize: true,
    },
  ],
};

export default BadgeConstants;